import contentDownloadHelpers from '../../helpers/contentCanBeDownloaded';
import collectionsHelpers from '../../helpers/pages/collections/collectionsHelpers';

import { CollectionDownloadListStateProps, CollectionDownloadListProps } from '../../types/components/collections/CollectionDownloadList';
import { CollectionVariantDownload } from '../../types/api/DownloadsTypes';
import { User } from '../../types/api/UsersTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { DownloadIcon } from '../../modules/Icons';
import EmailNotVerifiedDialog from '../shared/EmailNotVerifiedDialog';

import { useState } from 'react';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';

import downloadsHelpers from '../../helpers/downloadsHelpers';
const { sortCollectionDownloadsFunction } = downloadsHelpers;

import { QUERY_PARAMS as ALGOLIA_QUERY_PARAMS } from '../../constants/algolia';

const CollectionDownloadList: React.FC<CollectionDownloadListProps> = (props) => {
  const { downloads, collection, user } = props;
  const { prettyFileSize, downloadCollection } = collectionsHelpers;
  const { variantDownloadAllowedFor } = contentDownloadHelpers;

  const [emailNotVerifiedDialogOpen, setEmailNotVerifiedDialogOpen] = useState(false);

  const router = useRouter();

  const handleDownload = (download: CollectionVariantDownload) => {
    variantDownloadAllowedFor(user, collection.collection_variants, download, collection)
      ? downloadCollection(download.id, user, collection.id, router.query[ALGOLIA_QUERY_PARAMS.QUERY_ID] as string)
      : setEmailNotVerifiedDialogOpen(true);
  }

  return (
    <>
      <ul cy-test-id="collection-downloads-list">
        {downloads.sort(sortCollectionDownloadsFunction).map((d: CollectionVariantDownload) => (
          <li key={d.id} cy-test-id={`download-${d.id}`} className="pt-[8px] pb-[11px] px-5">
            <a
              className="flex gap-3 cursor-pointer hover:text-a-blue stroke-white hover:stroke-a-blue"
              cy-test-id="download-link"
              onClick={(e) => {
                e.stopPropagation();
                handleDownload(d);
              }}
            >
              <DownloadIcon className="inline" />
              <span cy-test-id="download-description">
                {d.resolution} {d.format}
              </span>
              <span className="text-gray-600" cy-test-id="file-size"> {prettyFileSize(d.size)}</span>
            </a>
          </li>
        ))}
      </ul>
      <EmailNotVerifiedDialog
        isOpen={emailNotVerifiedDialogOpen}
        setIsOpen={setEmailNotVerifiedDialogOpen}
      />
    </>
  )
};

const mapStateToProps = (state: ApplicationState): CollectionDownloadListStateProps => ({
  user: state.auth.user as User,
});

export default connect(mapStateToProps)(CollectionDownloadList);
